export default __webpack_public_path__ + "static/media/logo-light-sm.f26bf362.svg";